import axiosInstance from "auth/FetchInterceptor";
import { TRIP_DELAY_API } from "constants/ApiConstant";
const TripDelayService = {};

TripDelayService.getTripDelayConfigApi = function (data) {
  return axiosInstance.get(TRIP_DELAY_API, data);
};

TripDelayService.updateTripDelayApi = function (data) {
  return axiosInstance.put(TRIP_DELAY_API, data);
};

export default TripDelayService;
